import React, { Component } from "react";
import { connect } from "react-redux";
import {
	FiMoreHorizontal,
	FiChevronsUp,
	FiChevronsDown,
	FiLock,
} from "react-icons/fi";
import { FaFlask } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import RuleEditModal from "components/Rules/RuleEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as rulesActions from "actions/rulesActions";
import { rulesService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from 'react-i18next';
import { isCalculatedRuleType } from 'components/Rules/utils';

class RuleList extends Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditRuleModal = this.openEditRuleModal.bind(this);
		this.openDeleteRuleModal = this.openDeleteRuleModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditRuleModal(rule) {
		this.props.showModal(
			{
				open: true,
				title: rule.system
					? this.props.t('rules.viewRule')
					: this.props.t('rules.editRule'),
				style: { width: "670px" },
				content: <RuleEditModal rule={rule} handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteRuleModal(idRule) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('rules.deleteRule'),
				style: { width: "400px" },
				message: this.props.t('rules.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idRule),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('rules.deleteError'),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idRule) => {
		const response = await rulesService.remove(idRule);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.props.getAllRules();
			this.closeModal();
		}
	};

	getPrettyFormula = (rule) => {
		var formula_pretty = "";

		if (rule.formula && rule.accounts_in_formula) {
			formula_pretty = rule.formula;

			rule.accounts_in_formula.forEach((account) => {
				const name = account.name.replaceAll(" ", "_");
				formula_pretty = formula_pretty.replaceAll(
					"account_id=" + account.id,
					name
				);
			});
		}
		return formula_pretty;
	};

	isCalculatedRule(rule) {
		return isCalculatedRuleType(rule.type);
	}

	renderOperationIcon(rule) {
		if (this.isCalculatedRule(rule)) {
			return (
				<FaFlask
					title="Formula"
					aria-label="Formula"
					className="icon-operacion icon-formula"
				/>
			);
		}
		if (rule.is_add) {
			return (
				<FiChevronsUp
					title="Suma"
					aria-label="Suma"
					className="icon-operacion color-green"
				/>
			);
		}
		return (
			<FiChevronsDown
				title="Resta"
				aria-label="Resta"
				className="icon-operacion color-red"
			/>
		);
	}

	getRuleActions = (rule) => {
		const labelAction = rule.system ? this.props.t('common.view') : this.props.t('common.edit');
		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item
						as="button"
						onClick={() => this.openEditRuleModal(rule)}
					>
						{labelAction}
					</Dropdown.Item>
					{!rule.system && (
						<Dropdown.Item
							as="button"
							onClick={() => this.openDeleteRuleModal(rule.id)}
						>
							{this.props.t('common.delete')}
						</Dropdown.Item>
					)}
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	getDesktopColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			render: (rule) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditRuleModal(rule)}
				>
					{rule.name}
				</button>
			),
		},
		{
			key: "rule_type",
			header: this.props.t('rules.columns.type'),
			sortAccessor: (r) =>
				[r.type, r.shift?.name, r.time_type?.name, r.account_type]
					.filter(Boolean)
					.join(" "),
			render: (rule) => (
				<>
					<span className="label-mini">{rule.type}</span>
					{rule.shift && rule.shift.name}{" "}
					{rule.time_type && rule.time_type.name}{" "}
					{rule.account_type && rule.account_type}
				</>
			),
		},
		{
			key: "details",
			header: this.props.t('rules.columns.details'),
			render: (rule) => {
				const formula_pretty = this.getPrettyFormula(rule);
				return rule.account ? (
					<>
						<span className="label-mini">{this.props.t('rules.account')}</span> {rule.account.name}
					</>
				) : (
					<div className="substring">
						<span className="label-mini">{this.props.t('rules.formula')}</span>
						{formula_pretty}
					</div>
				);
			},
		},
		{
			key: "operation",
			header: "\u00A0",
			className: "td-icon",
			sortable: false,
			render: (rule) => this.renderOperationIcon(rule),
		},
		{
			key: "system",
			header: "\u00A0",
			className: "td-icon",
			sortable: false,
			render: (rule) =>
				rule.system ? (
					<FiLock className="icon-locked" title="Cuenta de sistema" />
				) : null,
		},
	];

	getEmptyRowMobile = () => (
		<tr>
			<td colSpan={4} className="no-result">
				Sin resultados
			</td>
		</tr>
	);

	getRowsMobile = () =>
		(this.props.rules || []).map((rule) => {
			const labelAction = rule.system ? this.props.t('common.view') : this.props.t('common.edit');
			const formula_pretty = this.getPrettyFormula(rule);

			return (
				<tr key={rule.id}>
					<td>
						<button
							type="button"
							className="btn-transparent btn-editable"
							onClick={() => this.openEditRuleModal(rule)}
						>
							{rule.name}
						</button>{" "}
						<br />
						<span className="label-mini">{rule.type}</span>
						{rule.shift && rule.shift.name}{" "}
						{rule.time_type && rule.time_type.name}{" "}
						{rule.account_type && rule.account_type}
						<br />
						{rule.account ? (
							<>
								<span className="label-mini">Cuenta</span> {rule.account.name}
							</>
						) : (
							<div className="substring">
								<span className="label-mini">{this.props.t('rules.formula')}</span>
								{formula_pretty}
							</div>
						)}
					</td>
					<td className="td-icon">{this.renderOperationIcon(rule)}</td>
					<td className="td-icon">
						{rule.system && (
							<FiLock className="icon-locked" title="Cuenta de sistema" />
						)}
					</td>
					<td className="td-actions">
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditRuleModal(rule)}
								>
									{labelAction}
								</Dropdown.Item>
								{!rule.system && (
									<Dropdown.Item
										as="button"
										onClick={() => this.openDeleteRuleModal(rule.id)}
									>
										{this.props.t('common.delete')}
									</Dropdown.Item>
								)}
							</Dropdown.Menu>
						</Dropdown>
					</td>
				</tr>
			);
		});

	render() {
		const rules = this.props.rules || [];

		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-rules table-mobile">
							<tbody>
								{rules.length === 0
									? this.getEmptyRowMobile()
									: this.getRowsMobile()}
							</tbody>
						</table>
					</div>
				</Mobile>

				<TabletOrDesktop>
					<DataTable
						tableClassName="table-rules table-desktop table-hover"
						tableStyle={{ backgroundColor: "#ffffff" }}
						columns={this.getDesktopColumns()}
						rows={rules}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t('common.noResults')}
						actionsColumn={{
							render: (rule) => this.getRuleActions(rule),
							className: "td-actions",
						}}
					/>
				</TabletOrDesktop>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.rulesReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllRules: (q) => dispatch(rulesActions.getAllRules(q)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RuleList));
